// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a342a73f","977":"40b44fd1"}[chunkId] + ".chunk.js";
};